export default [
    '36 36',
    '<path d="M34.046 17.251L31.0469 20.251L28.046 17.251M31.4137 19.501C31.4681 19.0085 31.4961 18.508 31.4961 18.001C31.4961 10.5451 25.4519 4.50098 17.9961 4.50098C10.5402 4.50098 4.49609 10.5451 4.49609 18.001C4.49609 25.4568 10.5402 31.501 17.9961 31.501C22.237 31.501 26.0212 29.5455 28.4961 26.487M17.9961 10.501V18.001L22.4961 21.001" fill="none" stroke="url(#paint0_linear_1892_1590)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
    '<defs>\n' +
    '<linearGradient id="paint0_linear_1892_1590" x1="34.046" y1="18.0217" x2="4.49609" y2="18.0217" gradientUnits="userSpaceOnUse">\n' +
    '<stop stop-color="var(--p-icon-gradient-stop, currentColor)"/>\n' +
    '<stop offset="1" stop-color="var(--p-icon-gradient-start, currentColor)"/>\n' +
    '</linearGradient>\n' +
    '</defs>'
]